var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"login-form-layout"},[_c('h2',{staticClass:"login-title color-main"},[_vm._v("电商后台管理")]),_vm._v(" "),_c('div',[_c('div',{attrs:{"id":"qr_login"}})])]),_vm._v(" "),_c('img',{staticClass:"login-center-layout",attrs:{"src":_vm.login_center_bg}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67eff8f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/index.vue
// module id = null
// module chunks = 